import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, ArrowUpRight, Instagram, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] border-t border-white/10 relative overflow-hidden grain"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10 z-[2]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo variant="footer" />
            <p className="font-outfit text-xs uppercase tracking-[0.3em] text-[#D9D9D9]/70 mt-5">
              A Studio for Brand Craft
            </p>
            <p className="font-outfit text-sm text-[#D9D9D9] mt-6 max-w-md leading-relaxed">
              A boutique digital marketing and creative strategy studio crafting refined, high-impact brand experiences.
            </p>
            <p className="font-outfit text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mt-6">
              An Ikoa Edge Company
            </p>

            <div className="flex items-center gap-4 mt-8">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 border border-white/15 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#D9D9D9] flex items-center justify-center transition-colors">
                <Instagram size={16} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn" className="w-10 h-10 border border-white/15 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#D9D9D9] flex items-center justify-center transition-colors">
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-outfit text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/work", label: "Work" },
                { to: "/insights", label: "Insights" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="font-outfit text-sm text-[#D9D9D9] hover:text-[#D4AF37] transition-colors gold-link"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-outfit text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
              Connect
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#D4AF37] mt-1 shrink-0" />
                <a href="tel:+919326800270" data-testid="footer-phone" className="font-outfit text-sm text-[#D9D9D9] hover:text-white transition-colors">
                  +91 93268 00270
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="text-[#D4AF37] mt-1 shrink-0" />
                <a
                  href="https://wa.me/919326800270"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp"
                  className="font-outfit text-sm text-[#D9D9D9] hover:text-white transition-colors"
                >
                  WhatsApp · +91 93268 00270
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#D4AF37] mt-1 shrink-0" />
                <a href="mailto:kirti@ikoaedge.com" data-testid="footer-email" className="font-outfit text-sm text-[#D9D9D9] hover:text-white transition-colors gold-link">
                  kirti@ikoaedge.com
                </a>
              </li>
            </ul>

            <Link
              to="/contact"
              data-testid="footer-cta-book"
              className="inline-flex items-center gap-2 mt-8 bg-[#D4AF37] text-black font-outfit font-medium px-6 py-3 uppercase tracking-[0.18em] text-xs hover:bg-[#F0C84B] transition-colors"
            >
              Start Your Project <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="hairline my-12" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-outfit text-xs text-[#D9D9D9]/60 tracking-wide">
            © {new Date().getFullYear()} The Indian Marketing. All rights reserved.
          </p>
          <p className="font-outfit text-[11px] uppercase tracking-[0.3em] text-[#D9D9D9]/50">
            Content · Creativity · Campaigns · Websites · Reels · Performance
          </p>
        </div>
      </div>
    </footer>
  );
}
